import PropTypes from 'prop-types';
import React from 'react';
import { ItemContentShape } from 'utils/shapes';
import { nl2br } from 'utils/text';
import { MEDIA_TYPES } from 'utils/constants';

const ArenaItemPreview = ({ title, type, itemContent }) => {
    if (itemContent.thumbnail_url) {
        return (
            <div className="arena__item__cover-wrapper">
                <img className="arena__item__image" alt={title} src={itemContent.thumbnail_url} />
                {type === MEDIA_TYPES.VIDEO && <div className="arena__item__cover arena__item__cover--video" />}
            </div>
        );
    } else if (itemContent.text) {
        return <div className="arena__item__text">{nl2br(itemContent.text)}</div>;
    }

    return null;
};

ArenaItemPreview.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    itemContent: ItemContentShape.isRequired,
};

export default ArenaItemPreview;



// WEBPACK FOOTER //
// ./src/components/arena/ArenaItemPreview.js